import { from, MonoTypeOperatorFunction, Observable, switchMap } from 'rxjs';
import { transformAndValidate } from 'class-transformer-validator';

type ClassType<T> = new (...args: unknown[]) => T;

export function transformAndValidatePipe<T extends object, R = T>(model: ClassType<T>): MonoTypeOperatorFunction<R>;
export function transformAndValidatePipe<T extends object, R = T[]>(model: ClassType<T>): MonoTypeOperatorFunction<R>;
export function transformAndValidatePipe<T extends object, R = T | T[]>(model: ClassType<T>): MonoTypeOperatorFunction<R> {
  return (obs: Observable<R>) => {
    return obs.pipe(
      switchMap((results: R) => {
        if (Array.isArray(results)) {
          return from(transformAndValidate(model, results as object[]) as unknown as Promise<R>);
        } else if (typeof results === 'string') {
          return from(transformAndValidate(model, results) as unknown as Promise<R>);
        } else {
          return from(transformAndValidate(model, results as object) as unknown as Promise<R>);
        }
      }),
    );
  };
}
